'use strict';
var MemberApp = angular.module('MemberApp');
MemberApp.constant('cookiesEnabled', (function() {
  var cookieEnabled = navigator.cookieEnabled;
  if (cookieEnabled === false) {
    return false;
  }
  /*Chrome forbids setting samesite secure cookie when browsing localhost,
   so need special logic to handle cookie availability check, or else there will be http 502 error
   */
  if (window.location.hostname === 'localhost' || window.location.hostname.indexOf('192.168.56.1') !== -1) {
    document.cookie = 'testcookie=1; path=/';
  }
  else {
    document.cookie = 'testcookie=1; path=/;samesite=none; Secure';
  }
  document.cookie = 'testcookie=1; path=/';
  cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
  if (!cookieEnabled) {
    return false;
  } else {
    document.cookie = 'testcookie=;expires=Thu, 01 Jan 1970 00:00:01 GMT; path =/; Samesite=none; Secure';
    return true;
  }
})());
